import React from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { useTheme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  makeStyles
} from "@material-ui/core";
import ActionButton from "./ActionButton";
import red from "@material-ui/core/colors/red";

const useStyles = makeStyles(() => ({
  cancel: {
    color: "#fff",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700]
    }
  },
  close : {
    color: red[500],
  }
}));

export default function CommentPopup({
  title,
  content,
  route,
  openDialog,
  closeDialog,
  comment,
  onCommentChange,
  onSubmit,
  onCancel,
  hideCancel,
  OkButtonText,
  CancelButtonText,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  OkButtonText = OkButtonText ? OkButtonText : "Ok";
  CancelButtonText = CancelButtonText ? CancelButtonText : "Cancel";

  const handleClose = () => {
    onCommentChange("")
    closeDialog(false);
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={openDialog}
        aria-labelledby="responsive-dialog-title"
        id={title}
      >
        <DialogTitle id="responsive-dialog-title" onClose={handleClose}>
          <div style={{ display: "flex" }}>
            <Typography variant="h6" component="div" style={{ flexGrow: 1, marginTop:"5px" }}>
              {title}
            </Typography>
            <ActionButton
              onClick={handleClose}
            >
              <CloseIcon className={classes.close}/>
            </ActionButton>
          </div>
        </DialogTitle>
        <DialogContent>
            <TextareaAutosize
                aria-label="minimum height"
                placeholder="Type here"
                value={comment}
                autoFocus
                style={{ width: 400, height: 100 }}
                onChange={(e) => onCommentChange(e.target.value)}
            />
        </DialogContent>
        <DialogActions>
        <Button href={route} onClick={onSubmit} color="primary" className={classes.cancel}>
            {OkButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
